import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { MOCK_HIGHLIGHT_MATCHES, Match } from "../../mock-data/mock-sports.data";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  sliders: any[] = [];
  events: any[] = [];
  activeTab = "Cricket"; // Default tab
  highlightMatches: Match[] = MOCK_HIGHLIGHT_MATCHES;
  
  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getSliderList().subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.length > 0) {
          this.sliders = res.data;
        } else {
          // Fallback if API is empty
          this.sliders = [{ imagePath: "https://royall444.com/api/users/images/slider-default-2025815182455745.jpg" }];
        }
      },
      error: () => {
        this.sliders = [{ imagePath: "https://royall444.com/api/users/images/slider-default-2025815182455745.jpg" }];
      }
    });

    this.apiService.getMarketsEventList('4').subscribe({
      next: (res: any) => {
        this.events = res.data || [];
      },
      error: (err) => console.error("Error fetching events", err)
    });
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  getFilteredEvents() {
    if (!this.events || this.events.length === 0) return [];
    // Basic filter mock. In reality, you check event.sportName or similar.
    return this.events.filter(e => e.sportName === this.activeTab || !e.sportName);
  }
}
